export const API_HOST="https://hlwy-api.sztitan.com/api/v1"
export const HOST="http://jns.sztitan.com"
export const GOOD_HOST="https://shopx-api.sztitan.com"
export const REDIRECT_URI='http://jns.sztitan.com/login'
export const APPID='wx7e0c885d6f8c4ec1' //prod


